import styled from '@emotion/styled'

const StyledDefaultContent = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
`

export default StyledDefaultContent
